module.exports = __webpack_public_path__ + "style/img/DI_icon_Model.28d02978.png";